import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fultonMOConfig } from "./data";

export default function FultonMOPage() {
  return <CityPageTemplate config={fultonMOConfig} />;
}